/*

    Oxygen WebHelp Plugin
    Copyright (c) 1998-2018 Syncro Soft SRL, Romania.  All rights reserved.

*/
import strings from './strings.js';

/**
 * get translated messages
 */
function getLocalization(localizationKey) {
    var toReturn = localizationKey;
    if (localizationKey in strings) {
        toReturn = strings[localizationKey];
    }
    return toReturn;
}

export default {
    getLocalization
};
